import type { MilkdownPlugin } from "@milkdown/kit/ctx";

import {
  remarkDirectivePlugin,
  remarkHeadingAttrsPlugin,
  remarkHeadingAttrsStringifyPlugin,
  remarkSpanPlugin,
  remarkSpanStringifyPlugin,
  remarkSuperscriptPlugin,
  remarkSuperscriptStringifyPlugin,
  remarkTypographyParsePlugin,
  remarkTypographyStringifyPlugin,
} from "../plugin";

/// @internal
export const plugins: MilkdownPlugin[] = [
  // Directive plugin for ::: divs and :span syntax
  remarkDirectivePlugin.plugin,
  remarkDirectivePlugin.options,
  // Superscript: ^text^ (parse and stringify)
  remarkSuperscriptPlugin.plugin,
  remarkSuperscriptPlugin.options,
  remarkSuperscriptStringifyPlugin.plugin,
  remarkSuperscriptStringifyPlugin.options,
  // Heading attributes: # Title {#id .class} (parse and stringify)
  remarkHeadingAttrsPlugin.plugin,
  remarkHeadingAttrsPlugin.options,
  remarkHeadingAttrsStringifyPlugin.plugin,
  remarkHeadingAttrsStringifyPlugin.options,
  // Pandoc native span syntax: [text]{.class}
  remarkSpanPlugin.plugin,
  remarkSpanPlugin.options,
  remarkSpanStringifyPlugin.plugin,
  remarkSpanStringifyPlugin.options,
  // Typography: --- ↔ —, -- ↔ –, ... ↔ …
  remarkTypographyParsePlugin.plugin,
  remarkTypographyParsePlugin.options,
  remarkTypographyStringifyPlugin.plugin,
  remarkTypographyStringifyPlugin.options,
];
